import THGTracker from '../../tracking/thg/THGTracker';
import Track from '../utils/tracking';
import attributes from './attributes';
import device from './device';
import experiment from './experiments';
import getEventData from './getEventData';
import JsonHelper from './jsonHelper';
import nonce from './nonce';
import property from './property';
import request from './request';
import server from './server';
import trackingErrors from './trackingErrors';

class BigQueryMetricRecorder {
  isEnabled() {
    const {settings} = window.start;
    if (settings.checkout_tracking_url && settings.checkout_tracking_enabled) {
      this.url = settings.checkout_tracking_url;
      return true;
    }
    return false;
  }
  
  doMetric(metricName, attribute, errors, eventType) {
    return new Promise((resolve) => {
      if (this.isEnabled()) {
        THGTracker.sendEvent(
          this.url,
          this.getEventData(metricName, attribute, eventType, errors),
        );
      }
      resolve();
    })
      .catch((error) => {
        Track.track(`Failed to send data to big query. ${error}`);
      });
  }
  
  getEventData(metricName, attribute, eventType, errors = []) {
    return JsonHelper.getJsonMessage(
      server.getServerData(),
      request.getRequestData(),
      property.getPropertyData(),
      device.getDeviceData(),
      trackingErrors.getErrors(errors),
      getEventData(eventType, metricName, []),
      experiment.getExperimentsData(),
      attributes.getAttributes(this.addAttributes(attribute)),
      nonce.getNonce(),
    );
  }
  
  addAttributes(attribute) {
    const customerId = window?.start?.customer?.customerId || 'UNKNOWN';
    return [
      ...attribute,
      attributes.getAttribute('orderNumber', window.start.orderNumber),
      {name: 'guest', value: window.start.guestCheckout},
      {name: 'customerId', value: customerId},
    ];
  }
}

export default function (metricName, attribute = [], errors = [], eventType = 'click') {
  return new BigQueryMetricRecorder().doMetric(metricName, attribute, errors, eventType);
}
